import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { faQuestion, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'request-status',
    template: `<span><fa-icon [icon]="iconQuestion"></fa-icon></span>{{ labels.request }}`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
    span{
        margin-right: 8px;
    }
    `]
})
export class RequestStatusComponent {
    public iconQuestion: IconDefinition = faQuestion;

    public labels: ILabels = {
        request: Yii.t("wui-shared-js", "En demande"),
    };
}
